module.exports = __webpack_public_path__ + "img/mobilelab_parked.14fdc6d1.svg";